<div class="layout-column custom-panel full-height">
  <div class="layout-row layout-align-start-center header">
      <span
        class="br-body-2 font-weight-600 primary-100" translate>Select Day</span>
    <span class="flex"></span>
    <bringoz-button type="tertiary"
                    (onClick)="onClose.emit()">
      <bringoz-icon iconName="close"></bringoz-icon>
    </bringoz-button>
  </div>
  <hr class="main-divider">

  <div class="layout-column flex overflow-auto">
    <div class="layout-column flex padding-10">
      <div *ngFor="let timestamp of dayOptions"
           class="layout-row layout-align-start-center margin-bottom-10 pointer"
           (click)="onDaySelect(timestamp);$event.stopPropagation();">
        <app-bringoz-radio-button
          [value]="timestamp"
          [isSelected]="selectedDayTimestamp === timestamp">
        </app-bringoz-radio-button>
        <span class="br-body-2 font-weight-400 primary-100 margin-left-10">
          {{ {timestamp: timestamp} | bringozDay: 'timestamp': 'long' }} {{ {timestamp: timestamp} | bringozDate: 'timestamp' }}
        </span>
        <span class="flex"></span>
        <div class="layout-row layout-align-start-center margin-right-5">
          <bringoz-icon iconName="leftover" class="margin-right-5"></bringoz-icon>
          <span
            class="br-body-2 font-weight-400 primary-100">{{ daysLeftoverJobsCountMap[timestamp] }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
